module.exports = {
  lib: require('./emojis'),
  ordered: require('./ordered'),
  fitzpatrick_scale_modifiers: ["🏻", "🏼", "🏽", "🏾", "🏿"]
}



//////////////////
// WEBPACK FOOTER
// ./~/emojilib/index.js
// module id = 502
// module chunks = 0